export const ProductId = {
  VERTICAL_BLIND: '1',
  ROLLER_BLIND: '2',
  ROLLER_SHUTTERS: '3',
  AWNING: '5',
  SHOP_FRONT_AWNING: '6',
  ROLLER_BLIND_CASSETTE: '7',
  SRS_AWNING: '8',
  EZE_AWNING: '9',
  PROTECTA_ZIP: '10',
  PROTECTA_STRAIGHT_DROP: '11',
  PROTECTA_DEEP_CHANNEL: '12',
  PROTECTA_PIVOT_ARM: '13',
  PROTECTA_WIRE_GUIDE: '14',
  PROTECTA_MULTI_STOP: '15',
  PROTECTA_XL: '16',
  PROTECTA_AUTO_ARM: '29',
  Z_BLINDS: '18',
  CURTAIN: '19',
  CBLINDS: '20',
  VEBLINDS: '21',
  FOLDING_ARM: '22',
  PLANTATION_SHUTTER: '4',
  TPLANTATION_SHUTTER: '23',
  APLANTATION_SHUTTER: '24',
  AAPLANTATION_SHUTTER: '25',
  PANEL_GLIDE: '26',
  ROMAN_BLIND: '27',
  PART: '28',
  MISCELLANEOUS: '30',
  SERVICES: '60',
  DOUBLE_CURTAIN:'31',
  ROLLER_BLINDS_GROUP: '32',
  VERTICAL_BLIND_GROUP: '33',
  ROLLER_SHUTTER_GROUP: '34',
  VEGBLINDS: '35',
  PLANTATION_SHUTTER_GROUP: '36',
  CURTAIN_GROUP: '37',
  DOUBLE_CURTAIN_GROUP: '38',
  ROLLER_BLIND_CASSETTE_GROUP: '39',
  PANEL_GLIDE_GROUP: '40',
  ROMAN_BLIND_GROUP: '41',
  Z_GROUP: '42',
  CURVER_GROUP: '43',
  T_PLANTATION_SHUTTER_GROUP: '44',
  AAPLANTATION_SHUTTER_GROUP: '45',
  APLANTATION_SHUTTER_GROUP: '46',
  PROTECTA_ZIP_GROUP: '47',
  PROTECTA_STRAIGHT_DROP_GROUP: '48',
  PROTECTA_DEEP_CHANNEL_GROUP: '49',
  PROTECTA_PIVOT_ARM_GROUP: '50',
  PROTECTA_WIRE_GUIDE_GROUP: '51',
  PROTECTA_MULTI_STOP_GROUP: '52',
  PROTECTA_XL_GROUP: '53',
  PROTECTA_AUTO_ARM_GROUP: '54',
  EZE_AWNING_GROUP: '55',
  SRS_AWNING_GROUP: '56',
  AWNINGS_GROUP: '57',
  SP_AWNING_GROUP: '58',
  FOLDING_ARM_GROUP: '59',

};

export const Attribute = {
  FITTING: 'fitting',
  CONTROL_STYLE: 'control_style',
  CONTROL_SIDE: 'control_side',
  STACK_DIRECTION: 'stack_direction',
} as const;

export type AttributeKey = typeof Attribute[keyof typeof Attribute];

export const Link = {
  YES: 'YES',
  NO: 'NO',
};

export const FabricRotation = {
  YES: 'YES',
  NO: 'NO',
};

export const PVCMaterialId = '1';

export const MaterialConstant = {
  PVC: 1,
  CLOTH_127MM: 63,
  CLOTH_100MM: 62,
  CLOTH_89MM: 61,
  BOOTOM_BAR: 65,
  BOTTOM_BRAND : 217,
  BRACKET: 241,
  OPERATION: 64,
  TRACK_BRAND: 228,
  TOP_ROLLER: 66,
  FABRIC: 67,
  CASSETTE_COLOUR: 114,
  PELMET: 117,
  BRACKET_COLOR : 245,
  GUIDE_COLOR: 118,
  BOTTOM_BAR_COLOR: 119,
  SLAT_PRIMARY_COLOR: 120,
  SLAT_SECONDARY_COLOR: 121,
  GUIDE_TYPE: 129,
  OPERATION_SHUTTER: 130,
  SHUTTER_TYPE: 144,
  PROTECTA_CATALOG: 150,
  PROTECTA_HOOD_COLOR: 164,
  PROTECTA_CHANNEL_COLOR: 165,
  PROTECTA_BOTTOM_BAR_COLOR: 166,
  PROTECTA_HOOD_SIZE: 167,
  TUBE_SIZE: 168,
  PROTECTA_OPERATION: 169,
  HOOD_COLOR: 190,
  VALANCE_STYLE: 191,
  BCAA: 192,
  AWNING_MOTOR: 200,
  SRS_COLOR: 184,
  HOOD_TYPE: 185,
  EZE_COLOR: 186,
  SHUTTER_COLOR : 126,
};

export const Colour = {
  WHITE: 1,
  ZINCALUMA: 26,
  NONE: 20,
  STAINLESS_STEEL :47,
};

export const SubType = {
  // PVC: 1
  SIDES_CHARLIE_2: 5,
  SIDES_VOGUE_1: 6,
  SIDES_BREEZE_1: 7,
  SIDES_SAXON_1: 8,
  SPLAIN_MADISON: 9,
  // CLOTH: 61 / 62 / 63
  FABRIC_VIBE: 10,
  FABRIC_VIBE_METALLIC: 11,
  FABRIC_MORETON_BAY: 12,
  FABRIC_PLAZA_PLUS: 13,
  FABRIC_KARMA: 14,
  ELEGANE: 15,
  TUSCAN: 16,
  OTHER_1: 17,
  OTHER_2: 18,
  OTHER_3: 19,
  JAI : 229,
  // OPERATION
  MANUAL_BLIND: 95,
  // BOOTOM_BAR: 65
  CLEAR_ANODISE_55M: 104,
  OVAL_BOTTOM_BAR : 219,
  SINGLE_BRACKET : 242,
  // TOP_ROLLER: 66
  TOP_ROLLER_38MM_55M: 111,
  // FABRIC: 67
  VIBE: 68,
  //  GUIDE_TYPE: 129
  '53->42': 140,
  // OPERATION_SHUTTER: 130
  MANUAL_SHUTTER: 131,
  // SHUTTER_TYPE: 144,
  RESIDEN_42MM_PER: 122,
  // PROTECTA_CATALOG: 150,
  VISTAWEAVE99: 151,
  // PROTECTA_PELMET_SIZE: 167,
  '120 x 129': 178,
  // PROTECTA_TOP_ROLLER_SIZE: 168,
  '70': 180,
  // PROTECTA_OPERATION: 169
  GEARBOX_91: 170,
  // VALANCE_STYLE: 191,
  STRAIGHT: 193,
  //  BCAA: 192,
  BELT: 196,
  '129-Protecta': 187,

  // PLANTATION SHUTTER
  PVC: 427,
  mm89: 338,
  TIMBER: 333,
  AALUMINIUM: 335,
  ALUMINIUM: 334,
  SIDE_HINGE: 371,
  HINGE: 383,
};

const ProductConstant = {
  SubType,
  Colour,
  // BlindType,
  MaterialConstant,
  PVCMaterialId,
  Link,
  Attribute,
  ProductId,
};

export default ProductConstant;
